import { object } from 'prop-types'
import React, { Fragment } from 'react'
import classnames from 'classnames'
import HrbTranslate from '../../../components/language/HrbTranslate'

const AssociateAutoAssignProducts = ({ associate }) => {

    const hasAssignments = associate?.isRteAssignable || associate?.isVirAssignable
    const styleClass = classnames('has-text-weight-medium',
        {
            'text-functional-green': hasAssignments,
            'text-grey': !hasAssignments
        })

    return <Fragment>
        {associate?.isRteAssignable && associate?.isVirAssignable &&
            <HrbTranslate text='AssociatesPage.ProductAssignments.Multiple' className={styleClass} />
        }
        {associate?.isRteAssignable && !associate?.isVirAssignable &&
            <HrbTranslate text='AssociatesPage.ProductAssignments.VDO' className={styleClass} />
        }
        {!associate?.isRteAssignable && associate?.isVirAssignable &&
            <HrbTranslate text='AssociatesPage.ProductAssignments.VIR' className={styleClass} />
        }
        {!associate?.isRteAssignable && !associate?.isVirAssignable &&
            <HrbTranslate text='AssociatesPage.ProductAssignments.None' className={styleClass} />
        }
    </Fragment>
}

AssociateAutoAssignProducts.whyDidYouRender = false

AssociateAutoAssignProducts.propTypes = {
    associate: object
}

export default AssociateAutoAssignProducts